import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const col1 = categories.slice(0, 5);
  const col2 = categories.slice(5, 10);
  const col3 = categories.slice(10, 14);

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <a href="/" className="inline-flex items-center gap-2 mb-4 no-underline">
              <span className="text-primary-500 font-heading font-bold text-xl">YOYBUY</span>
              <span className="text-foreground-700 font-light text-lg">Spreadsheet</span>
            </a>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5 max-w-xs">
              Самый удобный способ заказывать товары из Китая через простую таблицу. Прозрачные комиссии, быстрая доставка, полный контроль заказов.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap no-underline"
            >
              Перейти к YOYBUY
              <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-800 uppercase tracking-wider mb-4">Категории (1)</h4>
            <ul className="space-y-2.5">
              {col1.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline"
                  >
                    {cat.nameRu}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-800 uppercase tracking-wider mb-4">Категории (2)</h4>
            <ul className="space-y-2.5">
              {col2.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline"
                  >
                    {cat.nameRu}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-800 uppercase tracking-wider mb-4">Категории (3) & Инфо</h4>
            <ul className="space-y-2.5">
              {col3.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline"
                  >
                    {cat.nameRu}
                  </a>
                </li>
              ))}
              <li className="pt-2 border-t border-background-200/60">
                <a
                  href="/article/yoybuy-spreadsheet-guide"
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline"
                >
                  Руководство YOYBUY
                </a>
              </li>
              <li>
                <a href="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline">
                  Главная
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 YOYBUY Spreadsheet. Все права защищены.
          </p>
          <div className="flex items-center gap-5">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors no-underline">kaspreadsheet.com</a>
            <a href="/article/yoybuy-spreadsheet-guide" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors no-underline">Руководство</a>
            <a href="/" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors no-underline">Главная</a>
          </div>
        </div>
      </div>
    </footer>
  );
}